import { ref, computed } from "vue";
import Option from "@/const/Option";
import { Renraku, RenrakuOptions } from "@/types/KaisyaRenraku";
import { RenrakuService } from "@/service/RenrakuService";
import dayjs from "dayjs"

/*
 * 初期処理
 */
export function useInit() {
  const loading = ref(1); // APIで読み込みをする本数
  const isError = ref(false);

  const form = ref<Renraku>();
  form.value = {
    oshirase_id: 0,
    oshirase_type: Option.OSHIRASE_TYPE.KAISYA_RENRAKU,
    target_type: Option.KAISYA_RENRAKU_TARGET_TYPE.TO_ALL,
    target_buka_id: 0,
    target_user_ids: [],
    title: '',
    control_text: '',
    start_datetime: dayjs().format("YYYY/MM/DD"),
    end_datetime: dayjs().format("YYYY/MM/DD"),
    start_time: '00:00',
    end_time: '23:59',
    tmp_start_datetime: new Date(dayjs().format("YYYY/MM/DD")),
    tmp_end_datetime: new Date(dayjs().format("YYYY/MM/DD")),
    isKidoku: false,
    control_type: ''
  }

  // 部課オプション値保存用
  const srv = new RenrakuService();

  const option = ref<RenrakuOptions>();

  // マスタに登録されている全ての就業場所を取得します（オプション値）
  srv.getAllOptions().then(opt => {
    if (Object.keys(opt).length <= 0) {
      // エラー
      isError.value = true;
    }
    loading.value--;
    // とりあえず代入はする
    option.value = opt;
  });

  // 読み込み中か判断する
  const isLoading = computed(() => {
    return !(loading.value === 0 || isError.value)
  });

  return {
    isLoading,
    isError,
    form,
    option,
  }
}
